module.exports = __webpack_public_path__ + "static/img/cont42_01.12646df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont42_01.png
// module id = muad
// module chunks = 0